// eslint-disable-next-line import/prefer-default-export
export const b64toBlob = (b64Data, contentType, size) => {
    const sliceSize = size || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
};

export const savebase64AsPDF = (folderpath, filename, content, contentType) => {
    if (window.cordova.platformId === "android") {
        window.cordova.plugins.safMediastore
            .writeFile({
                filename,
                data: content,
                subfolder: "",
            })
            .then(() => {
                const finalPath = folderpath + filename;
                window.cordova.plugins.fileOpener2.open(finalPath, "application/pdf");
            })
            .catch(() => {});
    }

    if (window.cordova.platformId === "ios") {
        const DataBlob = b64toBlob(content, contentType);

        window.resolveLocalFileSystemURL(folderpath, (dir) => {
            dir.getFile(filename, { create: true }, (file) => {
                file.createWriter(
                    (fileWriter) => {
                        fileWriter.write(DataBlob);
                        const finalPath = folderpath + filename;
                        window.cordova.plugins.fileOpener2.open(finalPath, "application/pdf");
                    },
                    () => {},
                );
            });
        });
    }
};

export const savebase64AsType = (folderpath, filename, content, contentType) => {
    const DataBlob = b64toBlob(content, contentType);
    window.resolveLocalFileSystemURL(folderpath, (dir) => {
        dir.getFile(filename, { create: true }, (file) => {
            file.createWriter(
                (fileWriter) => {
                    fileWriter.write(DataBlob);
                    const finalPath = folderpath + filename;
                    window.cordova.plugins.fileOpener2.open(finalPath, contentType);
                },
                () => {},
            );
        });
    });
};
